/**
 * @file Race Day.
 */

/**
 * Race Day functions.
 *
 * Runs js specific to the Race Day template.
 */
const vRaceDay = () => {
	import('../../components/anchor-menu/anchor-menu').then((m) => m.default());
	import('../../components/dragon-gallery/dragon-gallery').then((m) =>
		m.default(),
	);
};

if (document.readyState !== 'loading') {
	vRaceDay();
} else {
	document.addEventListener('DOMContentLoaded', vRaceDay);
}
